import vcPiechart from './components/vc-piechart/piechart'

export default vcPiechart



// WEBPACK FOOTER //
// ./src/lib.js